// @ts-nocheck
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/display-name */
import React from "react";
import MaterialTable, {
  MTableToolbar,
  MTableEditRow,
  MTableEditField,
  MaterialTableProps,
} from "material-table";
import { makeStyles, createStyles } from "@material-ui/core";
import { Formik, Field, getIn } from "formik";
import { Icons } from "./Icons";
import { Options } from "./Options";
import { Localization } from "./Localization";

/** スタイル定義 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useToolbarStyles = makeStyles((_theme: Theme) =>
  createStyles({
    root: {
      minHeight: "24px",
      padding: 0,
      // backgroundColor: "#DDDDDD",
    },
  })
);

/** MaterialTable ヘッダー列既定スタイル */
export const ColumnBaseHeaderStyle = {
  fontSize: "0.7rem",
  padding: "0.25rem 0.5rem 0.25rem 0.5rem",
};

/** MaterialTable ヘッダー列既定スタイル(中央寄せ) */
export const ColumnBaseHeaderStyleCenter = {
  fontSize: "0.7rem",
  padding: "0.25rem 0.5rem 0.25rem 0.5rem",
  textAlign: "center" as "center",
};

/** MaterialTable セル列既定スタイル */
export const ColumnBaseCellStyle = {
  padding: "0.25rem 0.5rem 0.25rem 0.5rem",
};

/** MaterialTable セル列既定スタイル(中央寄せ) */
export const ColumnBaseCellStyleCenter = {
  padding: "0.25rem 0.5rem 0.25rem 0.5rem",
  textAlign: "center" as "center",
};

interface Props<T extends object> extends MaterialTableProps<T> {
  initialFormData?: T;
  validate?: (values: T) => { [k: string]: any };
}

/** 編集可能テーブル */
export function EditableTable<T extends object>(props: Props<T>) {
  const toolbarClasses = useToolbarStyles();

  const {
    icons,
    options,
    components,
    initialFormData,
    validate,
    ...others
  } = props;

  const FormikEditRow = (rowProps: any) => {
    return (
      <Formik
        initialValues={rowProps.data}
        onSubmit={(newData: any) => {
          if (rowProps.mode === "add") {
            // eslint-disable-next-line no-param-reassign
            delete newData.tableData;
          } else if (rowProps.mode === "update") {
            // eslint-disable-next-line no-param-reassign
            newData.tableData.editing = false;
          }
          rowProps.onEditingApproved(rowProps.mode, newData, rowProps.data);
        }}
        validate={validate}
      >
        {({ submitForm }) => (
          <MTableEditRow {...rowProps} onEditingApproved={submitForm} />
        )}
      </Formik>
    );
  };

  const FormikEditField = (fieldProps: any) => {
    return (
      // eslint-disable-next-line react/destructuring-assignment
      <Field name={fieldProps.columnDef.field}>
        {(args: any) => {
          const { field, form } = args;
          const { name } = field;
          const { errors, touched, setFieldValue } = form;

          return (
            <>
              <MTableEditField
                {...fieldProps}
                {...field}
                error={touched[name] && errors[name]}
                onChange={(newValue: any) => setFieldValue(name, newValue)}
                helperText={touched[name] && errors[name]}
              />
            </>
          );
        }}
      </Field>
    );
  };

  //--------------------
  // コンポーネント
  return (
    <div style={{ maxWidth: "100%" }}>
      <MaterialTable<T>
        {...others}
        icons={{ ...Icons, ...icons }}
        localization={Localization}
        options={{ ...Options, ...options }}
        components={{
          ...components,
          Toolbar: toolbarProps => (
            <div>
              <MTableToolbar classes={toolbarClasses} {...toolbarProps} />
            </div>
          ),
          EditRow: FormikEditRow,
          EditField: FormikEditField,
        }}
        initialFormData={initialFormData}
      />
    </div>
  );
}
